import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
    Drawer,
    List,
    ListItem,
    ListItemText,
    makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    drawer: {
        '& .MuiDrawer-paper': {
            width: 250,
        },
    },
    listItem: {
        '&.active': {
            backgroundColor: theme.palette.action.selected,
            borderLeft: `4px solid ${theme.palette.background.fruitSalad}`,
        },
    },
}));

const MobileTabsDrawer = (props) => {
    const {
        open,
        onClose,
        tabs,
        activeTab,
        onTabSelect,
        anchor,
    } = props;

    const classes = useStyles();

    const handleTabClick = (tabIndex) => {
        onTabSelect(tabIndex);
        onClose();
    };

    return (
        <Drawer
            anchor={anchor}
            open={open}
            onClose={onClose}
            className={classes.drawer}
        >
            <List>
                {tabs.map((item, index) => (
                    <ListItem
                        button
                        key={index}
                        disabled={item.disabled}
                        onClick={() => handleTabClick(index)}
                        className={clsx(classes.listItem, { active: activeTab === index })}
                    >
                        <ListItemText primary={item.title} />
                    </ListItem>
                ))}
            </List>
        </Drawer>
    );
};

MobileTabsDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    tabs: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
    })).isRequired,
    activeTab: PropTypes.number.isRequired,
    onTabSelect: PropTypes.func.isRequired,
    anchor: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
};

MobileTabsDrawer.defaultProps = {
    anchor: 'right',
};

export default MobileTabsDrawer;
